import { ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { format$Price } from 'utils/helpers/functions/formatPrice';

interface WorkersAllocBarProps {
    allocated: number;
    incomeAmount: number;
    overLimit: boolean;
}

const calcPercent = (allocated: number, incomeAmount: number): number => {
    if (incomeAmount > 0) {
        return Math.round((allocated / incomeAmount) * 1000) / 10;
    }
    return allocated > 0 ? 100 : 0;
};

const WorkersAllocBar = ({ allocated, incomeAmount, overLimit }: WorkersAllocBarProps) => {
    const { t } = useTranslation(['Objects']);
    const percent = calcPercent(allocated, incomeAmount);
    const barNow = Math.min(100, Math.max(0, percent));
    const variant = overLimit ? 'danger' : percent >= 99.5 ? 'success' : 'info';

    return (
        <div className="mb-3">
            <div className="d-flex justify-content-between align-items-baseline gap-2 mb-1">
                <span className="text-muted">
                    {t('expendTeamWorkers.allocated')}:{' '}
                    <strong className={overLimit ? 'text-danger' : 'text-body'}>
                        {format$Price(allocated)}
                    </strong>
                    <span className="text-muted">
                        {' '}
                        / {format$Price(incomeAmount)}
                    </span>
                </span>
                <span className={`fw-medium ${overLimit ? 'text-danger' : 'text-body'}`}>
                    {percent}%
                </span>
            </div>
            <ProgressBar
                now={barNow}
                variant={variant}
                className="expend-team-workers-progress"
            />
        </div>
    );
};

export default WorkersAllocBar;
